<template>
    <div :class="applyFormGroupClass">
        <lt-label
            :label="label"
            :tooltip-link="tooltipLink"
            :tooltip-text="tooltipText"
            :show-tooltip="showTooltip"
            :show-question-mark="showQuestionMark"
            :popper-content="popperContent"
            :for-tag="id"
            :show-tooltip-loader="showTooltipLoader"
        />
        <a @click="showPopup()">{{ rightlabel }}</a>
        <div :class="applyInputGroupClass">
            <span
                v-if="alignLeft"
                v-once
                :class="applyInputGroupAddonClass">{{ symbol }}</span>
            <input
                :id="id"
                ref="input"
                :maxlength="MaxLength"
                :class="applyInputClass"
                :tabindex="tabIndex"
                :type="type"
                :inputmode="inputmode"
                :value="isFocused ? editingValue : value"
                :readonly="readonly"
                :data-position="position"
                @input="updateValue"
                @focus="selectAll"
                @blur="inputBlur();formatValue();"
                @keydown="getKeyCode($event); allowOnlyNumeric($event)"
                @keyup="androidKeyPress"
            />
            <div
                v-if="showLoader === true"
                class="input-loader loader">
                <img
                    alt="lt-loader"
                    width="61"
                    height="60"
                    src="data:image/png;base64,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"
                />
            </div>
            <span
                v-if="alignRight"
                v-once
                :class="applyInputGroupAddonClass">{{ symbol }}</span>
        </div>
    </div>
</template>
<script>
    import Accounting from 'accounting';
    import LtLabel from './lt-label.vue';
    import trackData from '~/mixin/track-data';

    export default {
        components: {
            LtLabel,
        },
        mixins: [trackData],
        props: {
            label: {
                type: String,
                default: '',
            },
            value: {
                default: 0,
            },
            maxlength: {
                default: 9,
            },
            symbol: {
                type: String,
                default: '$',
            },
            symbolAligned: {
                type: String,
                default: 'left',
            },
            precision: {
                default: 0,
            },
            tooltipLink: {
                type: String,
                default: '',
            },
            tooltipText: {
                type: String,
                default: '',
            },
            applyInputClass: {
                default: 'form-control',
            },
            tabIndex: {
                default: '0',
            },
            applyInputGroupClass: {
                default: 'input-group',
            },
            applyFormGroupClass: {
                default: 'form-group',
            },
            applyInputGroupAddonClass: {
                default: 'input-group-addon',
            },
            id: {
                type: String,
                default: '',
            },
            type: {
                type: String,
                default: 'text',
            },
            inputmode: {
                type: String,
                default: undefined,
            },
            readonly: {
                default: false,
            },
            rightlabel: {
                type: String,
                default: '',
            },
            rightLabelLink: {
                default: '',
            },
            showTooltip: {
                default: false,
            },
            showQuestionMark: {
                default: '',
            },
            popperContent: {
                default: '',
            },
            maxValue: {
                default: Number.MAX_SAFE_INTEGER,
            },
            modelName: {
                default: null,
            },
            showLoader: {
                default: false,
            },
            showTooltipLoader: {
                default: false,
            },
        },
        data() {
            return {
                MaxLength: parseInt(this.maxlength, 10) + 4,
                keyCode: null,
                flag: true,
                position: 0,
                isFocused: false,
                editingValue: String(this.value || ''),
            };
        },
        computed: {
            alignLeft() {
                return this.symbolAligned === 'left';
            },
            alignRight() {
                return this.symbolAligned === 'right';
            },
        },
        mounted() {
            this.formatValue();
            this.setTracking();
        },
        updated() {
            this.setTracking();
        },
        created() {
            this.allowOnlyNumeric();
        },
        methods: {
            showPopup() {
                this.$emit('showPopup', true);
            },
            updateValue(event) {
                const value = event.target.value;
                const regex = /^(\d+\.?\d{0,9}|\.\d{1,9})$/;
                let inputRefValue = '';
                if (this.keyCode === 46 || this.keyCode === 8) {
                    const returnVal = Accounting.unformat(this.$refs.input.value);
                    this.editingValue = returnVal.toString();
                    this.$emit('input', returnVal);
                    event.preventDefault();
                    return false;
                }
                if (this.flag === true) {
                    if (value !== '') {
                        inputRefValue = this.$refs.input.value.match(regex)
                            ? this.$refs.input.value
                                ? this.$refs.input.value
                                : this.value
                            : this.value;
                        if (inputRefValue.length >= parseInt(this.maxlength, 10) + 1 && inputRefValue.indexOf('.') === -1) {
                            this.MaxLength = parseInt(this.maxlength, 10) + 1;
                            inputRefValue = inputRefValue.substr(0, this.maxlength);
                            this.$refs.input.value = inputRefValue;
                        } else {
                            const valueArr = inputRefValue.toString().split('.');
                            if (valueArr[1] !== undefined && valueArr[1] !== '' && valueArr[1].length > 3) {
                                const decimal = valueArr[1].substr(0, 3);
                                inputRefValue = `${valueArr[0]}.${decimal}`;
                                this.$refs.input.value = inputRefValue;
                            }
                            this.MaxLength = parseInt(this.maxlength, 10) + 4;
                        }
                    } else {
                        inputRefValue = '0';
                        this.$nextTick(() => {
                            inputRefValue = this.value;
                            this.editingValue = inputRefValue.toString();
                            this.$emit('input', inputRefValue);
                        });
                    }
                    this.editingValue = inputRefValue.toString();
                    this.$emit('input', inputRefValue);
                }
                return true;
            },
            formatValue() {
                let currentVal = this.value;
                if (this.value !== undefined && this.value !== '' && this.value.toString().indexOf(',') > 0) currentVal = this.value.replace(/,/g, '');
                currentVal = this.maxValue !== Number.MAX_SAFE_INTEGER && parseFloat(currentVal) > parseFloat(this.maxValue) ? this.maxValue : currentVal;

                this.$refs.input.value = Accounting.formatMoney(currentVal, { symbol: '', precision: this.precision });
            },
            inputBlur() {
                const data = this.modelName ? { model: this.modelName, maxValue: this.maxValue, value: this.$refs.input.value } : this.$refs.input.value;
                this.$emit('inputBlur', data);
                this.isFocused = false;
            },
            selectAll(event) {
                // Workaround for Safari bug
                // http://stackoverflow.com/questions/1269722/selecting-text-on-focus-using-jquery-not-working-in-safari-and-chrome
                this.isFocused = true;
                this.editingValue = Accounting.unformat(this.$refs.input.value).toString();
                this.$refs.input.value = this.editingValue;

                const { target } = event;
                target?.select();
                requestAnimationFrame(() => {
                    if (document.activeElement === target) {
                        target.select();
                    }
                });
            },
            setTracking() {
                trackData.set({ key: this.label, val: this.value });
            },
            allowOnlyNumeric(event) {
                const result = false;
                if (event && event.target) this.position = event.target.selectionStart;
                let isFlag = false;
                if (this.keyCode === 37 || this.keyCode === 39) {
                    this.$refs.input.value = this.value.toString().replace(/,/g, '');
                    this.editingValue = this.$refs.input.value;
                    this.$emit('input', this.$refs.input.value);
                }
                if (this.keyCode === 9 || this.keyCode === 13) {
                    this.formatValue();
                    this.editingValue = this.$refs.input.value;
                    this.$emit('input', this.$refs.input.value);
                }
                if ((this.keyCode >= 48 && this.keyCode <= 57) || (this.keyCode >= 96 && this.keyCode <= 105)) {
                    if (parseInt(event.key, 10) >= 0 && parseInt(event.key, 10) <= 9) {
                        isFlag = true;
                    }
                } else if (this.keyCode === 8 || this.keyCode === 9 || this.keyCode === 13 || this.keyCode === 46 || this.keyCode === 110 || this.keyCode === 190 || (this.keyCode >= 35 && this.keyCode <= 40)) {
                    isFlag = true;
                } else if (this.keyCode === 229) {
                    const reg = /^(\d+\.?\d{0,9}|\.\d{1,9})$/;
                    if (reg.test(this.$refs.input.value)) {
                        isFlag = true;
                    }
                }
                if (event && event.target) this.position = this.keyCode === 46 || this.keyCode === 8 ? event.target.selectionStart : Number(event.target.selectionStart) + 1;
                this.flag = isFlag;
                if (!isFlag) {
                    if (event) event.preventDefault();
                    else return false;
                }
                return result;
            },
            getKeyCode(event) {
                this.keyCode = Number(event?.keyCode || 0);
            },
            updateFormatedValue(formatedValue) {
                this.$refs.input.value = formatedValue;
            },
            androidKeyPress(event) {
                if (Number(event?.keyCode || 0) === 229) {
                    const reg = /^(\d+\.?\d{0,9}|\.\d{1,9})$/;
                    this.position = event.target.selectionStart;
                    if (!reg.test(this.$refs.input.value)) {
                        this.$refs.input.value = this.value;
                        if (event.target.selectionEnd !== this.position) {
                            event.target.selectionStart = this.position - 1;
                            event.target.selectionEnd = this.position - 1;
                            event.target.dataset.position = this.position - 1;
                            this.$refs.input.focus();
                            event.preventDefault();
                        }
                    }
                }
            },
        },
    };
</script>
